/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: block;
}

:host > div.label {
  padding: 5px 5px;
  font-size: 14px;
  font-weight: 600;
}`;
export { style };
//# sourceMappingURL=OptionGroup.style.js.map